import cx from 'classnames';
import React from 'react';
import { TCloudinaryImageBlockData } from '../types';
import CloudinaryResponsiveImage from '../../CloudinaryResponsiveImage/CloudinaryResponsiveImage';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';
import { withHighlightAsText } from '../../Highlight/services/withHighlightAsText';
import { parseWithoutNonBreakingSpaces } from '../services/parseWithoutNonBreakingSpaces';
import { HighlightSelectionHint, TCloudinaryImageHighlightBlockData } from '../../Highlight/types';

export const renderCloudinaryImage = (
  { file, caption }: TCloudinaryImageBlockData,
  highlightData?: TCloudinaryImageHighlightBlockData,
) => {
  const { file: highlightFile, caption: highlightCaption } = highlightData || {};
  return (
    <a href={file?.url}>
      <figure>
        <CloudinaryResponsiveImage
          containerClassName={cx('article__img', {
            'border-t2-primary-brandColor border-b-2 border-dashed hover:border-solid':
              file?.url === highlightFile?.url,
          })}
          crop="limit"
          image={file}
          alt={caption}
          {...getHighlightSelectionTipProps(HighlightSelectionHint.Image)}
        />
        <figcaption className="article__img-caption" {...getHighlightSelectionTipProps(HighlightSelectionHint.Caption)}>
          {parseWithoutNonBreakingSpaces(withHighlightAsText(caption, highlightCaption))}
        </figcaption>
      </figure>
    </a>
  );
};
